import styled from "styled-components";

const Button = styled.div`
  display: inline-block;
  cursor: pointer;
  background: #007aff;
  color: white;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: 600;
  border-radius: 2px;

  &:after {
    content: ${props => (props.open ? "'-'" : "'+'")};
  }
`;

export default Button;
